<template>
  <div class="lms-sidebar">
    <div class="lms-sidebar-header">
      <router-link to="/" class="dropdown-link pd-t-20" style="padding-left:15px">
        <div class="d-flex align-items-center justify-content-center wd-100p">
          <!-- <div class="avatar avatar-sm mg-r-8"> -->
            <!-- <img
              class="mg-r-10"
              v-if="!$store.state.app.skin.dark"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              :style="`max-width: 60px; max-height: 50px`"
            /> -->
            
          <!-- </div> -->
          <img src="https://res.gosmart.mn/media/logo/stf.png" style="max-width: 180px" />
          <!-- <span class="tx-20 tx-color-01 tx-semibold lh-1">{{
            $store.state.app.activeGroup.name
          }}</span> -->
        </div>
      </router-link>
    </div>
    <div class="lms-sidebar-body">
      <vue-custom-scrollbar
        style="height: calc(100vh - 120px)"
        class="pd-x-20 pd-b-20"
      >
      
        <ul class="sidebar-nav lms-nav">
          <li class="nav-item">
            <a class="nav-link nav-descr">
              МЕНЮ
            </a>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'stfResearcher' }"
              class="nav-link home"
              :class="{ active: $route.name == 'stfResearcher' }"
              role="button"
            >
              <!-- <svg-icon type="home" :active="$route.name == 'lmsParticipant'" fill="#eb4872" stroke="#adb1bd"></svg-icon> -->
              Нүүр
            </router-link>
          </li>
          <li class="nav-item show" v-if="!hasPermission(['stf_ubeg', 'stf_tax', 'stf_gaali'])" >
            <router-link
              :to="{
                name: 'stfResearcherList',
                params: {
                  type: 0,
                },
              }"
              class="nav-link course "
              :class="{
                active:
                  $route.name == 'stfResearcherList' ||
                  $route.name == 'stfAdApply' ||
                  $route.name == 'stfAdDetail',
              }"
              role="button"
              data-svg=""
            >
              <!-- <svg-icon type="learn" :active="$route.name == 'lmsCourses' || $route.name == 'lmsAttend'" fill="red" stroke="#adb1bd"></svg-icon>  -->
              Төслүүд
            </router-link>
            <nav class="nav">
              <router-link v-if="hideSpecial()"
                :to="{
                  name: 'stfResearcherList',
                  params: { type: 1 },
                }"
                :class="{ active: this.$route.params.type == 1 }"
                role="button"
              >
                <span
                  >Бүх нээлттэй төслүүд
                  <sup v-if="counts != undefined">{{ counts.allCount }}</sup>
                </span>
              </router-link>
              <router-link v-if="hideSpecial()"
                :to="{
                  name: 'stfResearcherList',
                  params: { type: 2 },
                }"
                :class="{ active: this.$route.params.type == 2 }"
                role="button"
              >
                <span
                  >Миний оролцсон
                  <sup v-if="counts != undefined">{{
                    counts.mustJoinCount
                  }}</sup>
                </span>
              </router-link>
              <router-link
                :to="{
                  name: 'stfResearcherList',
                  params: { type: 3 },
                }"
                :class="{ active: this.$route.params.type == 3 }"
                role="button"
              >
                <span
                  >Материал бэлдэж буй
                  <sup v-if="counts != undefined">{{ counts.joinedCount }}</sup>
                </span>
              </router-link>
              <router-link
                :to="{
                  name: 'stfResearcherList',
                  params: { type: 4 },
                }"
                :class="{ active: this.$route.params.type == 4 }"
                role="button"
              >
                <span
                  >Илгээсэн
                </span>
              </router-link>
              <router-link
                :to="{
                  name: 'stfResearcherList',
                  params: { type: 5 },
                }"
                :class="{ active: this.$route.params.type == 5 }"
                role="button"
              >
              <span v-if="!hideSpecial()">
                    Бүртгэгдсэн
                  </span>
                <span v-else>
                  <span>Санхүүжилт авсан</span>
                  <sup v-if="counts != undefined">{{
                    counts.finishedCount
                  }}</sup>
                </span>
              </router-link>
            </nav>
          </li>

          <li class="nav-item show" v-if="hasPermission(['stf_ubeg', 'stf_tax', 'stf_gaali'])" >
            <router-link
            :to="{
                  name: 'stfResearcherList',
                  params: { type: 10 },
                }"
              class="nav-link course "
              :class="{ active: this.$route.params.type == 10 }"
              role="button"
              data-svg=""
            >
              Цуцлагдсан төслүүд
            </router-link>
          </li>
         
          <li class="nav-item" v-if="!hasPermission(['stf_ubeg', 'stf_tax', 'stf_gaali'])">
            <a @click="$emit('do-logout')" href="javascript:void(0)" class="nav-link logout active">
              <!-- <feather type="calendar"></feather> -->
              <!-- <svg-icon type="calendar" stroke="#adb1bd"></svg-icon> -->
              Гарах
            </a>
          </li>
          
        </ul>

        
        <router-link v-if="featuredCourse.id>0" :to="{ name: 'lmsCourseView', params: { id: featuredCourse.id, bid: 0, iid: 0, bot: 0 }, }">
          <div class="bg-white rounded-20 mg-t-50 text-center pd-10">
            <div class="" style="margin-top: -50px">
              <img :src="`${myResBaseUrl}v4-assets/img2.png`" />
            </div>
            <div class="mg-t-10 text-muted">Онцлох сургалт</div>
            <h6>{{featuredCourse.name}}</h6>
            <button type="button" class="btn btn-primary btn-icon mg-t-10 rounded-20" style="margin-bottom: -25px" >
              <feather type="arrow-right" :width="32" :height="32"></feather>
            </button>
          </div>
        </router-link>

        <slot />

        <!-- <go-points
          class="mg-t-20"
          :userTaskId="$store.state.user.userInfo.profileId"
          v-if="
            $store.state.app.activeGroup.id != 9241 &&
              $store.state.app.activeGroup.id != 9249 &&
              $store.state.app.activeGroup.id != 9254
          "
        /> -->
      </vue-custom-scrollbar>
    </div>
    <div class="lms-sidebar-footer text-center d-flex align-items-center justify-content-center">
      <div v-if="$store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249" class="text-muted mg-b-20">
        <router-link :to="`/lms/contact`" class="link-01">
          <feather type="phone"></feather>
          <span class="mg-l-10 tx-12">Холбоо барих</span>        
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";

import svgIcon from "@/assets/svg/all.vue";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";

export default {
  components: {
    svgIcon,
    vueCustomScrollbar,
    goPoints: () => ({
      component: import("@/views/modules/lms/components/points"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    counts: {
      type: Object,
      default: () => {},
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hasPayment: false,
      hasEvent: false,
      hasEbarimt: false,
      auditrequestindex: 0,
      hasFeedback: false,
      myResBaseUrl: "https://res.gosmart.mn/",
      featuredCourse:{
        id: null,
        name: null,
      }
    };
  },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.fetchSpecies();

    let _pay = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "lmsAttendHasPayment"
    );
    if (_pay.length > 0 && _pay[0].value != undefined && _pay[0].value == "1") {
      this.hasPayment = true;
    }

    let _ebarimt = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "paymentEbarimt"
    );
    if (
      _ebarimt.length > 0 &&
      _ebarimt[0].value != undefined &&
      _ebarimt[0].value == "1"
    ) {
      this.hasEbarimt = true;
    }

    let _event = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "learnEventHide"
    );
    if (
      _event.length > 0 &&
      _event[0].value != undefined &&
      _event[0].value == "0"
    ) {
      this.hasEvent = true;
    }

    let _feedback = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "lmsFeedback"
    );
    if (
      _feedback.length > 0 &&
      _feedback[0].value != undefined &&
      _feedback[0].value == "1"
    ) {
      this.hasFeedback = true;
    }

    if (
      this.$store.state.user.userInfo.groupId == 9157 &&
      this.$store.state.user.userInfo.defaultTasks.organizationTaskId != null
    ) {
      this.auditrequestindex++;
    }
  },
  methods: {
    hideSpecial(){
      let rv=true;
        if(this.$store.state.user.userInfo.qualityPerc!=undefined && this.$store.state.user.userInfo.qualityPerc!=null
        && this.$store.state.user.userInfo.qualityPerc>0){
          rv= false;
        }
      return rv;
    },
    fetchSpecies() {
      request({
        api: { method: "GET", url: "v2/Learn/GetHomeFeaturedCourse" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          if(res.data.course!=undefined && res.data.course!=null){
            this.featuredCourse.id=res.data.course.id;
            this.featuredCourse.name=res.data.course.name;
          }
        }
      });
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    courseNavExpanded() {
      let rv = true;
      if (
        this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249
      ) {
        if (this.$route.name == "lmsCourses") {
          rv = true;
        } else {
          rv = false;
        }
      } else if (
        !(
          this.$route.name == "lmsParticipant" ||
          this.$route.name == "lmsCourses"
        )
      ) {
        rv = false;
      }
      return rv;
      //$route.name=='lmsCourses' && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)
    },
    // navopen(name) {
    //     if(name=='lmsCourses'){
    //       this.$router.push({
    //         name: 'lmsCourses',
    //         params:{
    //           md: 1,
    //           cnm: 'null',
    //           type:-1,
    //           d1: 'null',
    //           d2: 'null',
    //         }
    //       });
    //     }
    //     else if(this.$route.name!=name){
    //         this.$emit("route-changed");
    //         this.$router.push({ name: name });
    //     }
    // },
    // subNavOpen(id){
    //     this.$emit("sub-nav-change", id);
    // },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
  },
};
</script>

<style></style>
